import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

// Email Template service for API calls
export const emailTemplateService = {
  // Get all email templates with optional filters
  getEmailTemplates: async (params = {}) => {
    try {
      const {
        page = 1,
        is_active = ''  // Status filter parameter
      } = params;
      
      const queryParams = { page };
      if (is_active !== '') {
        queryParams.is_active = is_active;
      }
      
      const response = await api.get('/admin/email-templates', {
        params: queryParams
      });
      return normalizeApiResponse(response, 'templates');
    } catch (error) {
      throw error;
    }
  },

  // Get single email template by ID
  getEmailTemplate: async (templateId) => {
    try {
      const response = await api.get(`/admin/email-templates/${templateId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Create new email template
  createEmailTemplate: async (templateData) => {
    try {
      const response = await api.post('/admin/email-templates', templateData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Update email template
  updateEmailTemplate: async (templateId, templateData) => {
    try {
      const response = await api.put(`/admin/email-templates/${templateId}`, templateData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Delete email template
  deleteEmailTemplate: async (templateId) => {
    try {
      const response = await api.delete(`/admin/email-templates/${templateId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Preview email template with dynamic data
  previewEmailTemplate: async (templateId, previewData = {}) => {
    try {
      const response = await api.post(`/admin/email-templates/${templateId}/preview`, previewData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Test send email template
  testSendEmail: async (testData) => {
    try {
      const response = await api.post('/email-templates/test-send', testData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  }
};

export default emailTemplateService;